import React from 'react'

import LoadingState from 'components/LoadingState'

import { IndexLayoutHeader, IndexLayoutHeaderProps } from './IndexLayoutHeader'
import { Wrapper } from './IndexLayout.styles'
import Sidebar, { Variant } from './Sidebar'

interface IndexLayoutLoadingProps extends IndexLayoutHeaderProps {
  variant?: Variant
}

export const IndexLayoutLoading: React.FC<IndexLayoutLoadingProps> = ({
  headerLink,
  variant,
}) => (
  <Wrapper>
    <IndexLayoutHeader headerLink={headerLink} />
    {variant && <Sidebar variant={variant} />}
    <LoadingState />
  </Wrapper>
)
